module.exports = __webpack_public_path__ + "img/introduce1.8ff44f93.png";